(() => {
  const STORAGE_KEY = "milano__wishlist-items";
  const OBSERVER_TIMEOUT_MS = 15000;

  let initialized = false;
  let storagePatched = false;
  let wishlistDomObserver = null;

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  const originalSetItem = localStorage.setItem.bind(localStorage);

  function saveList(list) {
    originalSetItem(STORAGE_KEY, JSON.stringify(list));
  }

  function updateHeaderCount() {
    const count = getList().length;
    document.querySelectorAll(".wishlist-count").forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? "inline-flex" : "none";
    });
  }

  function patchLocalStorageSetItem() {
    if (storagePatched) return;

    localStorage.setItem = function (key, value) {
      if (key === STORAGE_KEY) {
        return;
      }
      originalSetItem(key, value);
    };

    storagePatched = true;
  }

  function syncUI() {
    const listStr = getList().map((id) => String(id));

    document.querySelectorAll("button-wishlist").forEach((el) => {
      const pid = String(el.getAttribute("data-product-id") || "");
      if (!pid) return;

      if (listStr.indexOf(pid) > -1) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });

    updateHeaderCount();
  }

  function toggleWishlist(pid) {
    const productId = String(pid);
    const list = getList().map((id) => String(id));
    const idx = list.indexOf(productId);

    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(productId);
    }

    saveList(list);
    syncUI();
  }

  function attachHandlers() {
    document.querySelectorAll("button-wishlist").forEach((el) => {
      if (el.dataset.ourHandler) return;
      el.dataset.ourHandler = "1";

      const newEl = el.cloneNode(true);
      if (!el.parentNode) return;
      el.parentNode.replaceChild(newEl, el);
      newEl.dataset.ourHandler = "1";

      newEl.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const pid = newEl.getAttribute("data-product-id");
        if (pid) toggleWishlist(pid);
      });

      newEl.addEventListener(
        "touchend",
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          const pid = newEl.getAttribute("data-product-id");
          if (pid) toggleWishlist(pid);
        },
        { passive: false }
      );
    });
  }

  function initWishlistPage() {
    const wishlistDiv = document.querySelector(".wishlist-page-main");
    if (!wishlistDiv) return;

    if (window.WishlistPageShopify) {
      window.WishlistPageShopify.mergeItems = function () {};
    }

    function attachPageRemove() {
      document
        .querySelectorAll(".wishlist-page-main button-wishlist")
        .forEach((el) => {
          if (el.dataset.pageHandler) return;
          el.dataset.pageHandler = "1";

          function doRemove(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const pid = String(el.getAttribute("data-product-id") || "");
            if (!pid) return;

            const list = getList().map((id) => String(id));
            const idx = list.indexOf(pid);
            if (idx > -1) {
              list.splice(idx, 1);
              saveList(list);
            }

            updateHeaderCount();

            const card = el.closest(".product-item, .swiper-slide, [class*='product']");
            if (!card) return;

            card.style.transition = "opacity 0.3s";
            card.style.opacity = "0";

            setTimeout(() => {
              card.remove();
              const remaining = document.querySelectorAll(
                ".wishlist-page-main button-wishlist"
              );
              if (remaining.length === 0) {
                const emptyMsg = document.querySelector(".wishlist-no-product-js");
                if (emptyMsg) emptyMsg.classList.remove("hidden");
              }
            }, 300);
          }

          el.addEventListener("click", doRemove, true);
          el.addEventListener("touchend", doRemove, {
            passive: false,
            capture: true,
          });
        });
    }

    attachPageRemove();

    new MutationObserver(() => {
      attachPageRemove();
    }).observe(wishlistDiv, { childList: true, subtree: true });
  }

  function hasWishlistUI() {
    return Boolean(document.querySelector("button-wishlist, .wishlist-page-main"));
  }

  function startWishlistObservers() {
    const root = document.getElementById("MainContent");
    if (!root) return;

    new MutationObserver((mutations) => {
      let needsAttach = false;

      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches("button-wishlist")) needsAttach = true;
          if (node.querySelector && node.querySelector("button-wishlist")) {
            needsAttach = true;
          }
        });
      });

      if (needsAttach) {
        syncUI();
        attachHandlers();
      }
    }).observe(root, { childList: true, subtree: true });
  }

  function initWishlist() {
    if (initialized) return true;
    if (!hasWishlistUI()) return false;

    initialized = true;
    patchLocalStorageSetItem();
    syncUI();
    attachHandlers();
    initWishlistPage();
    startWishlistObservers();

    return true;
  }

  function setup() {
    if (initWishlist()) return;

    const root = document.getElementById("MainContent");
    if (!root) return;

    wishlistDomObserver = new MutationObserver(() => {
      if (initWishlist() && wishlistDomObserver) {
        wishlistDomObserver.disconnect();
        wishlistDomObserver = null;
      }
    });

    wishlistDomObserver.observe(root, { childList: true, subtree: true });

    setTimeout(() => {
      if (wishlistDomObserver && !initialized) {
        wishlistDomObserver.disconnect();
        wishlistDomObserver = null;
      }
    }, OBSERVER_TIMEOUT_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup, { once: true });
  } else {
    setup();
  }

  window.addEventListener("storage", (e) => {
    if (e.key === STORAGE_KEY && initialized) {
      syncUI();
    }
  });

  window.__wishlistToggle = toggleWishlist;
  window.__wishlistGetList = getList;
  window.__wishlistSaveList = saveList;
})();
